module.exports = __webpack_public_path__ + "static/img/orderImg.fbb8f80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yonghu/orderImg.png
// module id = 452
// module chunks = 0